var path = '/static/assets/khapps/fms_app/partials/includes/fms_navbar_links.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;